import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, PanInfo } from 'framer-motion';
import { CheckIcon, DownloadIcon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
const slides = ['https://cdn.magicpatterns.com/uploads/nU5AWuH59NQgn455bjEgq8/ChatGPT_Image_20_may_2026,_01_02_53.png', 'https://cdn.magicpatterns.com/uploads/1JxcsvYk9kZzHWtFCMjYS2/ChatGPT_Image_20_may_2026,_01_05_37.png', 'https://cdn.magicpatterns.com/uploads/pQyw5GkRz8ovxPx3pDFjVL/ChatGPT_Image_20_may_2026,_01_06_43.png', 'https://cdn.magicpatterns.com/uploads/rfW1yF73EdPqBWqnvx2vVN/ChatGPT_Image_20_may_2026,_01_07_50.png'];
export function HeroSection() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setIndex(currentIndex => (currentIndex + 1) % slides.length);
    }, 4000);
    return () => window.clearInterval(interval);
  }, []);
  const handleDragEnd = (_: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    if (info.offset.x < -50) {
      setIndex(currentIndex => (currentIndex + 1) % slides.length);
    }
    if (info.offset.x > 50) {
      setIndex(currentIndex => (currentIndex - 1 + slides.length) % slides.length);
    }
  };
  return <section className="w-full bg-[#110038] py-20 md:py-28" data-id="element-241" data-mp="2p76bkhsczv2l">
      <div className="mx-auto max-w-6xl px-6" data-id="element-242" data-mp="2kd20pnfz32w8">
        <div className="grid items-center gap-12 md:grid-cols-2 md:gap-x-12 md:gap-y-8" data-id="element-243" data-mp="2z3hptdbieuzo">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="order-1 text-center md:text-left" data-id="element-244" data-mp="2u4esyg5onv2s">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#7C3AED]/40 bg-[#7C3AED]/20 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-[#C4B5FD]" data-id="element-245" data-mp="1dqom51n6ispg">
              <FileTextIcon className="h-3.5 w-3.5 text-[#E5A83B]" aria-hidden="true" data-id="element-246" data-mp="38umlicbzwgp4" />
              Material digital · PDF
            </div>
            <h1 className="mb-6 font-serif text-4xl font-bold leading-tight text-white md:text-5xl lg:text-6xl" data-id="element-247" data-mp="3iqfuxmuf3u2o">
              Dejen de pelear por todo y{' '}
              <span className="text-[#E5A83B]" data-id="element-248" data-mp="3rs71etws84xl">salven</span> su relación antes
              de que sea demasiado tarde
            </h1>
            <p className="mb-6 flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-[#C4B5FD] md:justify-start" data-id="element-249" data-mp="kujgco2rngm">
              <span aria-hidden="true" data-id="element-250" data-mp="5eyqsx195xi8">→</span> 20 páginas. Sin relleno. Solo el
              protocolo para los próximos 7 días.
            </p>
            <p className="mb-8 text-lg leading-relaxed text-[#A78BFA] md:text-xl" data-id="element-251" data-mp="ee2d09vput0y">
              Descubrí el protocolo de supervivencia emocional diseñado para
              frenar las discusiones diarias, evitar que el estrés externo
              destruya el vínculo y reactivar la intimidad, incluso si sienten
              que la rutina y el cansancio ya les ganaron.
            </p>
            <motion.a href="#oferta-final" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="mb-6 inline-flex w-full items-center justify-center rounded-xl bg-[#F5C518] px-8 py-5 text-center text-lg font-extrabold tracking-wide text-black shadow-[0_10px_30px_-8px_rgba(245,197,24,0.55)] transition-colors hover:bg-[#e6b800] md:w-auto" data-id="element-252" data-mp="1ut84kuyo61ss">
              SÍ, QUIERO CONOCER EL PLAN
            </motion.a>
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs text-[#C4B5FD] md:justify-start md:text-sm" data-id="element-253" data-mp="28t970eul1had">
              <span className="inline-flex items-center gap-1.5" data-id="element-254" data-mp="31igbdugpx13j">
                <DownloadIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-255" data-mp="31g3nl0oa3wik" />
                Descarga inmediata
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-256" data-mp="2pznvb7hfj749">
                <ShieldCheckIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-257" data-mp="2c30v8vu6k0u4" />
                7 días de garantía
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-258" data-mp="34rpsgjs47m0l">
                <FileTextIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-259" data-mp="38s08yqdj9utp" />
                PDF en cualquier dispositivo
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 28
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: 'easeOut'
        }} className="order-2 flex flex-col items-center" data-id="element-260" data-mp="2zyn4qsa0r6sb">
            <p className="mb-5 px-4 text-center text-sm font-bold tracking-wide text-[#C4B5FD] md:text-base" data-id="element-261" data-mp="1n0a78504l43">
              Esto es exactamente lo que vas a recibir en tu dispositivo:
            </p>
            <div className="relative w-full max-w-[560px] select-none overflow-hidden" style={{
            aspectRatio: '3 / 2'
          }} data-id="element-262" data-mp="ahohf3u50cvj">
              <AnimatePresence mode="wait" data-id="element-263" data-mp="3evmxeged3ezv">
                <motion.div key={index} initial={{
                opacity: 0,
                x: 32
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -32
              }} transition={{
                duration: 0.45,
                ease: 'easeOut'
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.18} onDragEnd={handleDragEnd} className="absolute inset-0 cursor-grab active:cursor-grabbing" data-id="element-264" data-mp="3ewy1khbpyori">
                  <img src={slides[index]} alt={`Demostración del material — vista ${index + 1}`} className="pointer-events-none h-full w-full object-contain" draggable={false} data-id="element-265" data-mp="ri9ebmnnt7tk" />
                </motion.div>
              </AnimatePresence>
            </div>
            <div className="mt-5 flex items-center justify-center gap-2.5" data-id="element-266" data-mp="168qgx9c163s1">
              {slides.map((_, slideIndex) => <button key={slideIndex} type="button" onClick={() => setIndex(slideIndex)} aria-label={`Ir a la diapositiva ${slideIndex + 1}`} className={`rounded-full transition-all duration-300 ${slideIndex === index ? 'h-2.5 w-8 bg-[#E5A83B]' : 'h-2.5 w-2.5 bg-[#C4B5FD]/35 hover:bg-[#C4B5FD]/60'}`} data-id="element-267" data-mp="dqcqvvwxrm3i" data-mpi={slideIndex} />)}
            </div>
          </motion.div>

          <motion.aside initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.65,
          delay: 0.25,
          ease: 'easeOut'
        }} className="order-3 rounded-2xl border border-[#7C3AED]/40 bg-[#0D002B] p-6 text-center md:max-w-[460px] md:text-left" aria-label="Resumen de la oferta" data-id="element-268" data-mp="3nep7aow1u1yi">
            <div className="flex flex-col items-center justify-between gap-3 sm:flex-row md:items-start" data-id="element-269" data-mp="2zrh36aacwyy2">
              <div data-id="element-270" data-mp="2vq599skg9rk2">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#E5A83B]" data-id="element-271" data-mp="nfclnv7oyf5k">
                  Oferta especial de hoy
                </p>
                <div className="mt-2 flex items-end justify-center gap-2 md:justify-start" data-id="element-272" data-mp="sdec517g5gr2">
                  <span className="text-lg text-[#A78BFA] line-through" data-id="element-273" data-mp="dgdn55gn3zwa">
                    $24.999
                  </span>
                  <span className="font-serif text-4xl font-bold text-white" data-id="element-274" data-mp="iht7swewo4e5">
                    $11.749
                  </span>
                  <span className="pb-1 text-sm font-semibold text-[#C4B5FD]" data-id="element-275" data-mp="9ftpm0s5mu9m">
                    ARS
                  </span>
                </div>
              </div>
              <span className="rounded-full bg-[#E5A83B]/15 px-3 py-1 text-sm font-extrabold text-[#E5A83B]" data-id="element-276" data-mp="3qtysg5gbkhdb">
                53% OFF
              </span>
            </div>
            <div className="my-5 grid gap-2 border-y border-[#7C3AED]/30 py-4 text-left text-sm text-[#C4B5FD]" data-id="element-277" data-mp="3hvn1u3fgdjkv">
              <span className="flex items-center gap-2" data-id="element-278" data-mp="3lyt655j090op">
                <CheckIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-279" data-mp="339g052nihsoi" />
                Acceso digital inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-280" data-mp="3ca5sfwdkd0xh">
                <CheckIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-281" data-mp="3c6qeiwvmlxxn" />
                5 bonus incluidos sin cargo
              </span>
              <span className="flex items-center gap-2" data-id="element-282" data-mp="3m4xt592g03wh">
                <CheckIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-283" data-mp="3h7e9ftmz6yx5" />
                Garantía total de 7 días
              </span>
            </div>
            <a href="#oferta-final" className="block w-full rounded-lg bg-[#F5C518] px-5 py-3.5 text-center text-sm font-extrabold text-black transition-colors hover:bg-[#e6b800]" data-id="element-284" data-mp="3qyshwqwwn92f">
              VER TODO LO QUE INCLUYE EL PLAN
            </a>
          </motion.aside>
        </div>
      </div>
    </section>;
}